function sanitizeSegment(value: string): string {
    return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9_-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}

export function windowId(scope: string, name: string, instance?: string | number): string {
    const base = `${sanitizeSegment(scope)}.${sanitizeSegment(name)}`;
    if (instance === undefined || instance === null) return base;
    return `${base}.${sanitizeSegment(String(instance))}`;
}
